import { createNode } from '@glueapp/graph-types';

export const LessThan = createNode({
    id: 'LessThan (<)',
    name: 'LessThan (<)',
    description: 'Puts out true if the first input is less than the second',
    aiDescription:
        'Checks if First is less than Second. Connect numbers to "First" and "Second" input ports; the "Output" port returns a boolean.',
    category: 'Comparison',
    color: '#46aa43',
    integration: undefined,
    inPorts: {
        First: {
            kind: 'number',
        },
        Second: {
            kind: 'number',
        },
    },
    outPorts: {
        Output: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.First < input.inPorts.Second } };
    },
});
